import React, { forwardRef } from 'react'

import { Form as Unform } from '@unform/web'
import PropTypes from 'prop-types'

import { FormProvider } from '@galo-monitor/forms'
import Loader from '@galo-monitor/web-components/Loader'

import { Container, LoaderContainer } from './styles'

const Form = forwardRef(({ loading, ...props }, formRef) => (
  <Container>
    {loading && (
      <LoaderContainer>
        <Loader width={ 100 } />
      </LoaderContainer>
    )}
    <FormProvider
      ref={ formRef }
      { ...props }
      UnformComponent={ Unform }
      noValidate
    >
      {props.children}
    </FormProvider>
  </Container>
))

Form.propTypes = {
  schemaConstructor: PropTypes.func,
  onSubmit: PropTypes.func,
  children: PropTypes.any,
  loading: PropTypes.bool
}

Form.defaultProps = {
  schemaConstructor: undefined,
  onSubmit: () => {},
  children: null,
  loading: false
}

export default Form
